/* PRODUCT PAGE · STORY TIME + BODY COUNT — sections/nhp-film-03-rating.liquid.
   The line at the fire's height (a little above the middle of the screen) glows; lines already told dim.
   When the board is well in view, the number tags drop onto their nails, one after another. */
(function () {
  var root = document.querySelector('[data-nhp-story]');
  if (!root) return;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lines = [].slice.call(root.querySelectorAll('[data-nhp-line]'));
  var camp = root.querySelector('[data-nhp-camp]');

  if (!reduce && lines.length) {
    var ticking = false;
    var tell = function () {
      ticking = false;
      var mark = innerHeight * 0.5;    // a line lights up once it is in the dark above the fire (the fire sits ~70% down)
      var now = -1;
      lines.forEach(function (l, i) { if (l.getBoundingClientRect().top < mark) now = i; });
      lines.forEach(function (l, i) {
        l.classList.toggle('is-now', i === now);
        l.classList.toggle('is-told', i < now);
      });
    };
    addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(tell); } }, { passive: true });
    tell();
  }

  if (camp) {
    if (reduce || !('IntersectionObserver' in window)) { camp.classList.add('is-in'); return; }
    new IntersectionObserver(function (e, obs) {
      if (!e[0].isIntersecting) return;
      camp.classList.add('is-in');
      obs.disconnect();
    }, { threshold: 0.45 }).observe(camp);
    /* the fire burns low while the board is up */
    new IntersectionObserver(function (e) { root.classList.toggle('is-verdict', e[0].isIntersecting); }, { threshold: 0.3 }).observe(camp);
  }
})();
